import React from 'react';
import Navbar from './components/Navbar';
import './App.css';
import Home from './components/pages/Home';
import { HashRouter as Router, Switch, Route } from 'react-router-dom';
import Survey123 from './components/pages/Survey123';
import Footer from './components/Footer';   // <-- THIS FIXES THE ERROR

function App() {
  return (
    <>
      <Router>
        <Navbar />
        <Switch>
          <Route path='/' exact component={Home} />
          <Route path='/survey' component={Survey123} />
        </Switch>

        <Footer />   {/* <-- now React knows what this is */}
      </Router>
    </>
  );
}

export default App;
